import React from 'react'
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import LockIcon from 'material-ui/svg-icons/action/lock';
import { path, pathOr, omit } from 'ramda';

const styles = {
  heavText: {
    fontWeight: 'bold',
  },
}
/*
 * componentType is an override of the class detection, currently
 * happens on the Partner Finder listing.
 *
 * skipClick is relevant for matches that apply via the reducer,
 * not sending it when there is a match at the same time it will
 * efectively override it's settings.
 *
*/
const WallWrapper = ({
  amazonOrange = false,
  blocker = false,
  children: propsChildren,
  classes: css,
  componentType,
  hideOnSkip = false,
  lockIcon = false,
  openSlug,
  plan,
  skipClick = false,
  skipBack = false,
  slug = 'upgrade-general',
  upgradeStyle = {},
}) => {
  const shouldAction = Boolean(plan === 'basic' || plan === 'free');
  if (!shouldAction) {
    if (hideOnSkip) return <span />;
    return propsChildren;
  }
  const childType = componentType || path(['type', 'muiName'], propsChildren) ||
    path(['type', 'name'], propsChildren);
  const children = (() => {
    return React.Children.map(
      propsChildren,
      child => {
        const { props } = child;
        const disabledLabelColor = 'rgba(0, 0, 0, 0.5)';
        const fontColor = props.disabled ? disabledLabelColor : 'black';
        return React.cloneElement(child, {
          ...(blocker ? {
            onClick: undefined,
            onTouchTap: undefined,
          } : {}),
          ...(lockIcon && /(.*)Button/.test(childType) ? {
            icon: (<LockIcon style={{ fill: (amazonOrange ? fontColor : '#FFD700') }} />),
          }: {}),
          ...(!lockIcon && path(['icon', 'props', 'style', 'color'], props) ? {
            icon: {
              ...props.icon,
              props: {
                ...props.icon.props,
                style: {...pathOr({}, ['props', 'style'], props.icon), color: fontColor },
              },
            },
          } : {}), // there is an instance where the icon is defined
          ...(Object.keys(upgradeStyle).length > 0 ? { style: upgradeStyle } : {}),
          ...(amazonOrange ? (() => {
            const backgroundColor = props.disabled ? 'rgba(255, 193, 7, 0.85)' : '#ffc107';
            const backgroundColorMenuItem = 'rgba(255, 193, 7, 0.5)';
            const labelStyle = { ...(props.labelStyle || {}), fontWeight: 'bold' };
            if (/RaisedButton(.*)/.test(childType)) {
              return {
                backgroundColor,
                disabledBackgroundColor: backgroundColor,
                labelColor: 'black',
                disabledLabelColor,
                primary: undefined,
                secondary: undefined,
                labelStyle,
              };
            }
            if (/(.*)Button/.test(childType)) {
              return {
                backgroundColor,
                primary: undefined,
                secondary: undefined,
                labelStyle: {
                  ...labelStyle,
                  color: fontColor,
                },
                style: omit(['color'], props.style) // some instances use the root color
              };
            }
            if (childType === 'MenuItem') {
              return {
                style: { ...omit(['backgroundColor'], props.style), backgroundColor: backgroundColorMenuItem },
              }
            }
            if (typeof childType === 'undefined' && propsChildren.type === 'div') {
              return {
                style: { ...omit(['backgroundColor'], props.style), backgroundColor: backgroundColorMenuItem },
              }
            }
            return {};
          })(): {}),
        });
      },
    );
  })();
  const handleClick = e => {
    if (blocker) e.preventDefault();
    openSlug({ slug, blocker, skipBack })
  }
  if (skipClick) return (<div>{children}</div>);
  return (
    <div onClick={handleClick}>
      {children}
    </div>
  );
};

export default connect(
  ({ user }) => ({
    plan: user.getIn(['company', 'plan']) || 'basic',
  }),
  {
    openSlug: payload => ({
      type: '[wall] openSlug',
      payload,
    })
  },
)(injectSheet(styles)(WallWrapper));



// WEBPACK FOOTER //
// ./src/app/components/wall/wrapper.js